import React, { Component } from "react";
import M from "materialize-css";
import './Subscription.css';
import 'materialize-css/dist/css/materialize.min.css';
import one from '../../assets/tracker-assets/speech_therapy.png';
import two from '../../assets/tracker-assets/psycologist.png';
import three from '../../assets/tracker-assets/pediatrics.png';
import four from '../../assets/tracker-assets/dermatology.png';
import five from '../../assets/tracker-assets/optometrist.png';

class Carousel extends Component {
  componentDidMount() {
    const options = {
      duration: 300,
      onCycleTo: () => {
        console.log("New Slide");
      }
    };
    M.Carousel.init(this.Carousel, {
      dist: -50,
      shift: 10,

    });

    //Instance Plugin
    // let instance = M.Carousel.getInstance(this.Carousel);
    // instance.next(2);
  }

  render() {
    return (
      <div ref={Carousel => {
          this.Carousel = Carousel;
        }} className="carousel">
        <a className="carousel-item">
          <div className="card1-bg" style={{backgroundColor: 'blueviolet'}}>
            <div>
              <div style={{ display: 'inline' }}><i class="fas fa-rupee-sign"></i> <span className="carousel-text">16.</span><span>99/month</span></div>
              <h5>Standard</h5></div>

          </div>
          <p>15GB Disk Space</p>
          <p>25GB Bandwidth</p>
          <p>10 Database</p>
          <p>5 FTP Account</p>
          <p>10 Member Access</p>

          <button className="choose-btn">CHOOSE</button>
        </a>
        <a className="carousel-item">
          <div className="card1-bg" style={{backgroundColor:'#17eb29'}}>
            <div>
              <div style={{ display: 'inline' }}><i class="fas fa-rupee-sign"></i> <span className="carousel-text">24.</span><span>99/month</span></div>
              <h5>Standard</h5></div>

          </div>
          <p>15GB Disk Space</p>
          <p>25GB Bandwidth</p>
          <p>10 Database</p>
          <p>5 FTP Account</p>
          <p>10 Member Access</p>

          <button className="choose-btn">CHOOSE</button>
        </a>
        <a className="carousel-item">
        <div className="card1-bg" style={{backgroundColor:'#e45f12'}}>
            <div>
              <div style={{ display: 'inline' }}><i class="fas fa-rupee-sign"></i> <span className="carousel-text">16.</span><span>99/month</span></div>
              <h5>Standard</h5></div>

          </div>
          <p>15GB Disk Space</p>
          <p>25GB Bandwidth</p>
          <p>10 Database</p>
          <p>5 FTP Account</p>
          <p>10 Member Access</p>

          <button className="choose-btn">CHOOSE</button>
        </a>

      </div>
    );
  }
}

export default Carousel;
